import {generate} from '../lang/array';
import {integer} from '../lang/random';
import {encode} from './base64';

const crypto = window.crypto || window.msCrypto;

export default (
    (crypto && typeof Uint8Array !== 'undefined') ?
        length => encode(crypto.getRandomValues(new Uint8Array(length))) :
        length => encode(generate(length, () => integer(0, 0xff))));
